<template>
	<modal
		class="integration-modal"
		size="medium"
		@close="close">
		<template slot="header">
			<h3><i class="material-icons">book</i>WD Bulk Update</h3>
		</template>
		<template slot="body">
			<div class="form-control mb-3">
				<input type="file" @change="onSelectFile">
			</div>
			<div class="mb-3">
				<a :href="exampleLink" target="_blank">Download Example</a>
			</div>
			<progress-bar
				:value="progress"
				:show-label="true"
				v-if="isUpdating"
			/>
		</template>
		<template slot="footer">
			<button
				type="button"
				class="btn btn-default"
				:disabled="isUpdating"
				@click="close">
				Cancel
			</button>
			<button
				type="button"
				class="btn btn-primary"
				:class="{ 'is-loading': isUpdating }"
				:disabled="!isFormValid"
				@click="startBulkUpdateStatus">
				Start
			</button>
		</template>
	</modal>
</template>

<script>
import readXlsxFile from 'read-excel-file';
import Modal from '@/components/Modal.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import walletApi from '@/api/wallet';
// import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'WdUpdateModal',
	components: {
		Modal,
		ProgressBar,
	},
	props: {
		oldDatas: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			file: null,
			rows: [],
			items: [],
			idColIndex: 0,
			statusColIndex: 1,
			withdrawals: [],
			oldData: {},
			exampleLink: 'https://orderonline.s3-ap-southeast-1.amazonaws.com/examples/wd-bulk-update.xlsx',
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		onSelectFile(event) {
			const files = event.target.files;
			if (files.length > 0) {
				this.isSubmitting = true;
				const file = files[0];
				this.file = file;
			}
		},
		startBulkUpdateStatus() {
			readXlsxFile(this.file).then(this.processRows);
		},
		processRows(rows) {
			let filteredRows = rows;
			filteredRows.splice(0, 1);
			filteredRows = filteredRows.filter(item => !!item);
			this.rows = filteredRows;
			const statusKey = this.statusColIndex;
			const idKey = this.idColIndex;
			const mapper = (row) => {
				console.log(row, idKey, statusKey);
				const rawId = row[idKey] ? String(row[idKey]) : '';
				const formattedId = rawId.replace(/\D/g, '');
				const id = Number.parseInt(formattedId);
				const status = row[statusKey] ? row[statusKey] : '';
				const oldData = this.findObjectById(id);
				const withdrawal = { id, status, oldData };
				return withdrawal;
			};
			const withdrawals = filteredRows.map(mapper);
			this.withdrawals = withdrawals;
			this.submit();
		},
		findObjectById(id) {
			return this.oldDatas.find(obj => obj.id === id);
		},
		submit() {
			if (this.withdrawals.length <= 0) {
				return;
			}
			const withdrawal = this.withdrawals[0];
			const id = withdrawal.id;
			const params = {
				status: withdrawal.status,
				old_status: withdrawal.oldData.status,
			};
			const callback = (response) => {
				const history = response.data;
				this.$emit('update', history);
				this.withdrawals.splice(0, 1);
				if (this.withdrawals.length === 0) {
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Withdrawals Bulk Update',
						text: 'Multiple Withdrawals has been updated',
					});
				}
				this.submit();
			};
			const errorCallback = () => {
				this.withdrawals.splice(0, 1);
				this.submit();
			};
			walletApi.updateHistory(id, params, callback, errorCallback);
		},
	},
	computed: {
		isFormValid() {
			return this.file;
		},
		isUpdating() {
			return this.withdrawals.length > 0;
		},
		progress() {
			const all = this.rows.length;
			const notUpdated = this.withdrawals.length;
			const updated = all - notUpdated;
			const progress = updated / all;
			const percentage = parseInt(progress * 100);
			return percentage;
		},
	},
};
</script>
